export default "__VITE_ASSET__IK3M5QRm__"